@if (mode === 'icon') {
  @switch (autoSaveStatus) {
    @case (AutoSaveStatus.BeginSave) {
      <mat-progress-spinner
        data-cy="autosave-status-begin"
        diameter="20"
        color="primary"
        mode="indeterminate"
      ></mat-progress-spinner>
    }
    @case (AutoSaveStatus.SaveSuccess) {
      <img
        data-cy="autosave-status-success"
        class="success"
        src="dist/tiime-material/assets/ic_check.svg"
        alt="Icône sauvegarde réussie"
      />
    }
    @case (AutoSaveStatus.SaveError) {
      <img
        data-cy="autosave-status-error"
        class="error"
        src="dist/tiime-material/assets/ic_warn.svg"
        alt="Icône sauvegarde échouée"
        [tiimeTooltip]="errorMessage"
        [tooltipDisabled]="!errorMessage"
      />
    }
  }
} @else {
  @switch (autoSaveStatus) {
    @case (AutoSaveStatus.BeginSave) {
      <span data-cy="autosave-status-text-begin" class="begin">Enregistrement en cours...</span>
    }
    @case (AutoSaveStatus.SaveSuccess) {
      <span data-cy="autosave-status-text-success" class="success">Enregistré !</span>
    }
    @case (AutoSaveStatus.SaveError) {
      <span data-cy="autosave-status-text-error" class="error">Erreur lors de l'enregistrement</span>
    }
  }
}
